import React from 'react';
import { Modal as MaterialModal } from '@material-ui/core';
import Button from 'src/components/Button/Button';
import { useTranslation } from 'react-i18next';

interface ModalContainerProps {
  onClose: () => void,
  balance: number,
  onApprove: () => void,
  setComments: Function
}

function ModalContainer({ onClose, balance, onApprove, setComments }: ModalContainerProps) {
  const { t } = useTranslation();

  const checkTitle = () => {
    if (balance === 0){
      return t('adminSession.userBalanced');
    } else if (balance > 0){
      return t('adminSession.userOver', { value: balance });
    }
    return t('adminSession.userShort', { value: Math.abs(balance) });
  };
  return (
    <MaterialModal
      disableEscapeKeyDown={ true }
      open={ true }
      onClose={ onClose }
      className="modal"
    >
      <div className="modal-container">
        <div className="cancel-ticket__modal">
          <h3 className="cancel-ticket__subtitle">{
            checkTitle()
          }</h3>
          <div className="cancel-ticket__comments">
            <input
              type="text"
              className="session__input session__input--value session__input--value--full"
              placeholder={ t('adminSession.comments') }
              onChange={ (e) => setComments(e.target.value) }
            />
          </div>
          <div className="cancel-ticket__buttons">
            <Button
              type="button"
              text={ t('adminSession.approveSession') }
              className="btn btn--cta"
              onClick={ onApprove }
            />
            <Button
              type="button"
              text={ t('adminSession.cancelSession') }
              className="btn btn--cta cancel-ticket__button cancel-ticket__button--cancel"
              onClick={ onClose }
            />
          </div>
        </div>
      </div>
    </MaterialModal>

  );
}

export default ModalContainer;
